<template>
  <JoszakiCard>
    <content-placeholders rounded class="flex md:flex-row flex-col gap-3">
      <div class="w-full md:w-80 h-52">
        <content-placeholders-img class="!h-full" />
      </div>
      <div class="h-32 md:grow">
        <content-placeholders-heading :lines="2" />
        <content-placeholders-text :lines="2" />
      </div>
    </content-placeholders>
  </JoszakiCard>
</template>

<script>
export default {
  name: "InspirationListItemPlaceholder",
};
</script>
